// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KYCzA1Fdn4KCri {
  display: flex;
  align-items: center;
  height: 100%;
}
.Pw0DiRX7ELc0ku {
  display: inline-block;
  flex: 0 0 auto;
  width: 28px;
  height: 20px;
  border-radius: 3px;
  background-size: cover;
}
.RTLs5o7N6kEIEL {
  display: flex;
  position: relative;
  flex: 1 1 auto;
  padding: 2px 0 2px 10px;
  overflow: hidden;
  opacity: 1;
}
.eSXGiJwtzW3LDP {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.125;
  background-position: center center;
  background-size: cover;
}
.TWYGR8kAEZPXmG,
.T0NuuAyCJNVzfu {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.TWYGR8kAEZPXmG {
  margin-left: 6px;
  font-size: 14px;
  line-height: 24px;
}
.F6bFJYKvJLUKcA {
  display: flex;
  align-items: center;
}
.F6bFJYKvJLUKcA .nQsdGD2vnaEvE5 {
  margin-right: 5px;
}
.BMZSJvSbP_9kaG {
  padding: 8px 12px;
}
.LH34Q_ZkTduHSD {
  /* stylelint-disable-next-line declaration-no-important */
  color: var(--ds-text, #172b4d) !important;
}
.MwIMissA768Emj input {
  /* stylelint-disable-next-line declaration-no-important */
  box-shadow: none !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTile": `KYCzA1Fdn4KCri`,
	"boardThumbnail": `Pw0DiRX7ELc0ku`,
	"boardDescription": `RTLs5o7N6kEIEL`,
	"boardBackground": `eSXGiJwtzW3LDP`,
	"boardName": `TWYGR8kAEZPXmG`,
	"boardSubName": `T0NuuAyCJNVzfu`,
	"groupLabel": `F6bFJYKvJLUKcA`,
	"groupLabelIcon": `nQsdGD2vnaEvE5`,
	"boardSelectorOption": `BMZSJvSbP_9kaG`,
	"boardSelectorOptionIsSelected": `LH34Q_ZkTduHSD`,
	"boardSelector": `MwIMissA768Emj`
};
export default ___CSS_LOADER_EXPORT___;
